import Button from "components/common/Button";
import React, { useEffect, useRef, useState } from "react";
import AddNotes from "./AddNotes";
import Dropdown from "components/common/Dropdown";
import TextInput from "components/common/InputField/TextInput";
import Avatar from "components/common/Avatar";
import VendorAvatar from "components/common/VendorAvatar";
import ModalContainer from "components/common/ModalContainer";
import NoteDetails from "./NoteDetails";
import useGetSpaceNotes from "hooks/spaceHooks/useGetSpaceNotes";
import { useParams, useSearchParams } from "react-router-dom";
import moment from "moment";
import { spaceActions } from "redux/Ldb/actions/spaceActions";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import CustomToast from "components/common/CustomToast";
import toast from "react-hot-toast";
import { useMergedSearchParams } from "helpers/mergeSearchParams";
import { Space } from "redux/Ldb/types/spaceTypes";
import { truncate } from "lodash";
import Skeleton from "react-loading-skeleton";
import Loader from "components/common/Loader";

type SpaceDetailsNoteTabProps = {
    spaceData: Space | null;
};
export default function SpaceDetailsNoteTab(props: SpaceDetailsNoteTabProps) {
    const { spaceData } = props;
    const { spaceId } = useParams();
    const scrollContainer = document.getElementById("scrollContainer");
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const noteIdParams = searchParams.get("noteId");
    const [noteId, setNoteId] = useState<string>("");
    const [addNote, setAddNote] = useState<boolean>(false);
    const [recentlyViewed, setRecentlyViewed] = useState<string>("");
    const [createdBy, setCreatedBy] = useState<string>("");
    const [deleteNote, setDeleteNote] = useState<boolean>(false);
    const [refetch, setRefetch] = useState<boolean>(false);
    const [selectedNote, setSelectedNote] = useState<any>(null);
    const [selectedNoteId, setSelectedNoteId] = useState<string>("");
    const { updateSearchParams } = useMergedSearchParams();

    const {
        deleteSpaceNoteSuccess,
        deletingSpaceNote,
        pinningSpaceNote,
        unpinningSpaceNote,
        pinSpaceNoteSuccess,
        unpinSpaceNoteSuccess,
    } = useAppSelector((state) => state.space);
    const {
        spaceNotes,
        fetchingSpaceNotes,
        handleDebouncedSearch,
        pagination,
        setPagination,
        search,
        setSearch,
        isLoadingMore,
        setMemberId,
        memberId,
        setSortBy,
        sortBy,
        fetching,
    } = useGetSpaceNotes(scrollContainer, spaceId, refetch);

    const handleDeleteNote = () => {
        dispatch(spaceActions.deleteSpaceNote(spaceId, selectedNoteId));
    };

    const handlePinNote = (noteId: string) => {
        dispatch(spaceActions.pinSpaceNote(spaceId, noteId));
    };

    const handleUnpinNote = (noteId: string) => {
        dispatch(spaceActions.unpinSpaceNote(spaceId, noteId));
    };

    useEffect(() => {
        if (Boolean(pinSpaceNoteSuccess)) {
            setRefetch(!refetch);

            toast.custom((t) => (
                <CustomToast t={t} message={"Note added to favorites"} type={"success"} />
            ));
            dispatch(spaceActions.resetPinSpaceNote());
        }
    }, [dispatch, pinSpaceNoteSuccess]);

    useEffect(() => {
        if (Boolean(unpinSpaceNoteSuccess)) {
            setRefetch(!refetch);

            toast.custom((t) => (
                <CustomToast t={t} message={"Note removed from favorites"} type={"success"} />
            ));
            dispatch(spaceActions.resetUnpinSpaceNote());
        }
    }, [dispatch, unpinSpaceNoteSuccess]);

    useEffect(() => {
        if (Boolean(deleteSpaceNoteSuccess)) {
            setRefetch(!refetch);
            toast.custom((t) => <CustomToast t={t} message={"Note deleted"} type={"success"} />);
            dispatch(spaceActions.resetDeleteSpaceNote());
            setDeleteNote(false);
            setSelectedNoteId("");
            setSelectedNote("");
            if (noteId) {
                updateSearchParams({
                    noteId: "",
                });
            }
        }
    }, [dispatch, deleteSpaceNoteSuccess]);

    useEffect(() => {
        if (noteIdParams) {
            setNoteId(noteIdParams);
        } else {
            setNoteId("");
        }
    }, [noteIdParams]);

    const sortByOptions = [
        {
            label: "Recently viewed",
            value: "lastViewedAt",
        },
        {
            label: "Last updated",
            value: "lastEditedAt",
        },
    ];

    return (
        <div className="">
            {!noteId && !addNote && (
                <div className="px-[24px]">
                    <div className="sticky top-0 bg-white z-10 flex items-center space-x-2 mt-4 mb-6 max-sm:grid max-sm:space-x-0 max-sm:space-y-2 max-sm:grid-cols-1">
                        <TextInput
                            name={"search"}
                            value={search}
                            type={"text"}
                            inputPlaceholder={"Search notes"}
                            inputClassName={"!h-[38px] pl-[0px] !bg-white text-sm !mb-0"}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                            onInput={handleDebouncedSearch}
                            containerClassname={"!w-full"}
                            leftIcon={
                                <i className="ri-search-line before:content-['\f0d1] text-slate-400 mt-[2px]"></i>
                            }
                            inputContainerClassname={
                                "!rounded-[4px] max-sm:!w-full !pl-[25px] !h-[40px] !bg-white !border !border-slate-200"
                            }
                        />

                        <Dropdown
                            name="filter"
                            value={""}
                            dropdownTriggerClassName={" "}
                            handleChange={(name, value) => {
                                setSortBy(value);
                            }}
                            dropdown={
                                <div className="bg-white flex items-center max-sm:justify-between h-10 gap-2 py-2.5 px-3 shadow-boxShadow-2 border border-slate-200 !rounded">
                                    <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium">
                                        {sortBy
                                            ? sortByOptions?.find(
                                                  (option) => option.value === sortBy
                                              )?.label
                                            : "Sort by"}
                                    </span>

                                    <div className="flex items-center space-x-2">
                                        {sortBy && (
                                            <i
                                                onClick={(e) => {
                                                    e?.stopPropagation();
                                                    setSortBy("");
                                                }}
                                                className="ri-close-circle-fill text-sm text-slate-500"
                                            ></i>
                                        )}
                                        <i className="ri-arrow-down-s-line text-lg text-gm-50"></i>
                                    </div>
                                </div>
                            }
                            wholeContainerClass={`max-sm:!w-full`}
                            dropdownItemsClasses=" !py-2"
                            dropdownClassName={`shadow-cardShadow-4 -left-[120px]  border border-slate-100 !w-[159px] rounded !max-h-fit`}
                            dropdownContainerClasses={`shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] -right-0 !h-[200px] overflow-y-auto   border border-slate-200 rounded !max-h-fit !py-0 `}
                            dropdownOptions={sortByOptions}
                        />

                        <Dropdown
                            name="filter"
                            value={""}
                            dropdownTriggerClassName={" "}
                            handleChange={(name, value) => {
                                setMemberId(value?.split("//")[0]);
                                setCreatedBy(value?.split("//")[1]);
                            }}
                            dropdown={
                                <div className="bg-white flex items-center max-sm:justify-between h-10 gap-2 py-2.5 px-3 shadow-boxShadow-2 border border-slate-200 !rounded">
                                    <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium">
                                        {createdBy
                                            ? truncate(createdBy, { length: 15 })
                                            : "Created by"}
                                    </span>

                                    <div className="flex items-center space-x-2">
                                        {createdBy && (
                                            <i
                                                onClick={(e) => {
                                                    e?.stopPropagation();
                                                    setCreatedBy("");
                                                    setMemberId("");
                                                }}
                                                className="ri-close-circle-fill text-sm text-slate-500"
                                            ></i>
                                        )}
                                        <i className="ri-arrow-down-s-line text-lg text-gm-50"></i>
                                    </div>
                                </div>
                            }
                            wholeContainerClass={`max-sm:!w-full`}
                            dropdownItemsClasses=" !py-2"
                            dropdownClassName={`shadow-cardShadow-4 -left-[120px]  border border-slate-100 !w-[159px] rounded !max-h-fit`}
                            dropdownContainerClasses={`shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] -right-0 !h-[200px] overflow-y-auto   border border-slate-200 !w-[250px] rounded !max-h-fit !py-0 !min-w-[0px]`}
                            dropdownOptions={spaceData?.members?.map((member) => {
                                const name =
                                    member?.type === "guest"
                                        ? `${
                                              member?.firstName || member?.lastName
                                                  ? `${member?.firstName || ""} ${
                                                        member?.lastName || ""
                                                    }`
                                                  : member?.guest?.email
                                          }`
                                        : member?.ldb?.fullName || member?.ldb?.email;
                                return {
                                    label: (
                                        <div className="flex justify-between max-w-[350px] gap-2">
                                            <div className="flex items-center gap-2">
                                                <VendorAvatar
                                                    size={16}
                                                    imageSrc={
                                                        member?.type === "guest"
                                                            ? ""
                                                            : member?.ldb?.profile?.avatar || ""
                                                    }
                                                    name={name}
                                                />
                                                {name}
                                            </div>

                                            {member?.type === "guest" && (
                                                <p className="text-sm text-slate-500 ">Guest</p>
                                            )}
                                        </div>
                                    ),
                                    value: `${
                                        member?.type === "guest" ? member?.guestId : member?.ldbId
                                    }//${name}`,
                                };
                            })}
                        />

                        <div className="!w-fit">
                            <Button
                                btnClassname="!py-2.5 !px-4 !w-[100px]"
                                btnText="Add note"
                                onClick={() => {
                                    setAddNote(true);
                                }}
                            />
                        </div>
                    </div>

                    <div
                        className="overflow-y-auto max-h-[600px] h-[70vh] overflow-x-hidden"
                        id="scrollContainer"
                    >
                        {fetching && !isLoadingMore && !search && !memberId && !sortBy ? (
                            <div className="">
                                {[1, 2, 3, 4, 5]?.map((item, index) => {
                                    return (
                                        <div key={index} className="">
                                            <Skeleton
                                                height={50}
                                                width="100%"
                                                highlightColor="#E2E8F0"
                                                borderRadius={16}
                                                baseColor="#F1F5F9"
                                                className="custom-skeleton"
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        ) : spaceNotes?.length > 0 ? (
                            <>
                                <div className="border border-slate-100 rounded-[6px] ">
                                    {spaceNotes?.map((item, index) => (
                                        <div
                                            className={`py-3 px-4 border-b cursor-pointer border-b-slate-100 ${
                                                index === spaceNotes.length - 1 ? "!border-b-0" : ""
                                            }`}
                                            key={index}
                                            onClick={() => {
                                                setSelectedNoteId(item?._id);
                                                setSelectedNote(item?.name);
                                                updateSearchParams({
                                                    noteId: item?._id,
                                                });
                                            }}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 bg-[#00C6FA] rounded-md flex items-center justify-center">
                                                        <i className="ri-sticky-note-fill text-[#CCF4FE] text-base"></i>
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <p className="text-sm font-rocGroteskMedium text-g-75">
                                                            {item?.name || "Untitled note"}
                                                        </p>
                                                        <p className="text-xs font-rocGroteskMedium text-slate-500">
                                                            Added by{" "}
                                                            {item?.createdBy?.ldb?.fullName ||
                                                                item?.createdBy?.ldb?.email ||
                                                                item?.createdBy?.ldb?.profile
                                                                    ?.businessName ||
                                                                item?.createdBy?.guest?.email}
                                                            -{" "}
                                                            {moment(item?.createdAt).format(
                                                                "MMM D, YYYY"
                                                            )}{" "}
                                                            | Last viewed:{" "}
                                                            {moment(item?.updatedAt).format(
                                                                "MMM D, YYYY"
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="flex items-center gap-2">
                                                    <VendorAvatar
                                                        size={20}
                                                        imageSrc={
                                                            item?.createdBy?.ldb?.profile?.avatar ||
                                                            ""
                                                        }
                                                        name={
                                                            item?.createdBy?.ldb?.fullName ||
                                                            item?.createdBy?.ldb?.email ||
                                                            item?.createdBy?.ldb?.profile
                                                                ?.businessName ||
                                                            item?.createdBy?.guest?.email
                                                        }
                                                    />
                                                    <i
                                                        onClick={(e) => {
                                                            e?.stopPropagation();
                                                            if (
                                                                pinningSpaceNote ||
                                                                unpinningSpaceNote
                                                            )
                                                                return;
                                                            if (item?.isFavorite) {
                                                                handleUnpinNote(item?._id);
                                                            } else {
                                                                handlePinNote(item?._id);
                                                            }
                                                        }}
                                                        className={`ri-star-fill  text-[#FCD34D] text-sm cursor-pointer ${
                                                            item?.isFavorite
                                                                ? "text-[#FCD34D]"
                                                                : "text-slate-200"
                                                        }`}
                                                    ></i>
                                                    <div
                                                        className=""
                                                        onClick={(e) => {
                                                            e?.stopPropagation();
                                                        }}
                                                    >
                                                        <Dropdown
                                                            value={""}
                                                            dropdown={
                                                                <i className="ri-more-2-fill text-base text-slate-500 !z-0 relative"></i>
                                                            }
                                                            dropdownItemsClasses=" !py-2"
                                                            dropdownClassName={`shadow-cardShadow-4 -left-[120px]  border border-slate-100 !w-[159px] rounded !max-h-fit`}
                                                            dropdownContainerClasses={`shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] !right-0  border border-slate-200 !w-[159px] rounded !max-h-fit !py-0 !text-gm-50 !text-sm`}
                                                            name={"faq-dropdown"}
                                                            dropdownOptions={[
                                                                {
                                                                    label: "Open",
                                                                    value: "open",
                                                                    action: (event) => {
                                                                        setSelectedNoteId(
                                                                            item?._id
                                                                        );
                                                                        setSelectedNote(item?.name);
                                                                        updateSearchParams({
                                                                            noteId: item?._id,
                                                                        });
                                                                    },
                                                                },
                                                                {
                                                                    label: item?.isFavorite
                                                                        ? "Remove from favorites"
                                                                        : "Add to favorites",
                                                                    value: "fav",
                                                                    action: () => {
                                                                        if (item?.isFavorite) {
                                                                            handleUnpinNote(
                                                                                item?._id
                                                                            );
                                                                        } else {
                                                                            handlePinNote(
                                                                                item?._id
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                                {
                                                                    label: "Delete",
                                                                    value: "delete",
                                                                    action: (event) => {
                                                                        setDeleteNote(true);
                                                                        setSelectedNoteId(
                                                                            item?._id
                                                                        );
                                                                        setSelectedNote(item?.name);
                                                                    },
                                                                    labelClassName:
                                                                        "!text-[#E4281D] !text-sm",
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {fetchingSpaceNotes && isLoadingMore && (
                                    <div className="flex justify-center my-4">
                                        <Loader color="gm-25" size={4} />
                                    </div>
                                )}
                            </>
                        ) : search || memberId || sortBy ? (
                            <div className="h-[200px] flex items-center justify-center max-w-[350px] mx-auto text-center font-rocGroteskMedium">
                                <div className="">
                                    <p className="text-g-75 text-base">No results</p>
                                    <p className="text-slate-500 font-rocGroteskMedium text-sm ">
                                        We couldn't find any notes that match your filter. Try
                                        adjusting your filters or clear them to see all notes again.
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <div className="flex justify-center items-center flex-col gap-4 mt-28 font-rocGroteskMedium">
                                <i className="ri-sticky-note-line text-lg text-[#000000]"></i>
                                <p className="text-g-75 text-base">No notes yet</p>

                                <p className="text-sm text-slate-500 max-w-[368px] text-center">
                                    Notes help you capture important context, ideas, and references
                                    within a space. Start by creating your first note to keep your
                                    team aligned.
                                </p>
                                <Button
                                    btnClassname="!py-2 !px-4 !w-fit !h-10"
                                    btnText="Add your first note"
                                    onClick={() => {
                                        setAddNote(true);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}

            {addNote && <AddNotes setAddNote={setAddNote} addNote={addNote} />}
            {noteId && (
                <NoteDetails noteId={noteId} setNoteId={setNoteId} setDeleteNote={setDeleteNote} />
            )}

            <ModalContainer
                open={deleteNote}
                modalClassName={"py-10 px-10"}
                tailwindClassName="md:w-[500px] w-[90%] "
                showCloseIcon={false}
                closeModal={() => {
                    if (!deletingSpaceNote) {
                        setDeleteNote(false);
                        setSelectedNoteId("");
                        setSelectedNote("");
                    }
                }}
            >
                <div className="bg-white px-6 py-4  shadow-cardShadow  rounded-[8px]">
                    <div className="flex items-center justify-between">
                        <h1 className="text-base mb-1 text-[#142837] font-rocGroteskMedium">
                            Delete note
                        </h1>
                        <i
                            className="ri-close-line text-g-75 text-lg cursor-pointer -mt-2"
                            onClick={() => {
                                if (!deletingSpaceNote) {
                                    setDeleteNote(false);
                                    setSelectedNoteId("");
                                    setSelectedNote("");
                                }
                            }}
                        ></i>
                    </div>
                    <p className="text-slate-500 font-rocGroteskMedium text-sm">
                        Are you sure you want to delete {selectedNote} note? This action cannot be
                        undone.
                    </p>
                    <div className="flex justify-end items-center mt-6">
                        <div className="flex items-center !whitespace-nowrap space-x-2  ">
                            <Button
                                btnText={"No, cancel"}
                                type={"button"}
                                btnClassname={"!bg-n-20 !w-fit !text-gm-50"}
                                onClick={() => {
                                    setDeleteNote(false);
                                    setSelectedNoteId("");
                                    setSelectedNote("");
                                }}
                                disabled={deletingSpaceNote}
                            />
                            <Button
                                btnClassname={"!py-3 !w-fit !bg-[#E4281D] !text-white"}
                                onClick={() => {
                                    handleDeleteNote();
                                }}
                                btnText={"Delete note"}
                                type={"button"}
                                isLoading={deletingSpaceNote}
                                disabled={deletingSpaceNote}
                            />
                        </div>
                    </div>
                </div>
            </ModalContainer>
        </div>
    );
}
